import { useState } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';

import '../../utils/styles/TabBar.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faHouse,
    faLightbulb,
    faNewspaper,
    faChampagneGlasses,
    faUtensils,
    faBeerMugEmpty,
    faBook,
    faFutbolBall,
    faDice,
    faTruckMedical,
    faCircleInfo,
    faCompass,
    faEllipsis,
} from '@fortawesome/free-solid-svg-icons';

const mainLinks = [
    { to: '/', icon: faHouse, text: 'Accueil' },
    { to: '/tips', icon: faLightbulb, text: 'Tips' },
    { to: '/events', icon: faChampagneGlasses, text: 'Événements' },
    { to: '/arsenal', icon: faUtensils, text: 'Arsenal' },
];

const extraLinks = [
    { to: '/actualites', icon: faNewspaper, text: 'Actualités' },
    { to: '/plan-campus', icon: faCompass, text: 'Plan du campus' },
    { to: '/be-responsible', icon: faBeerMugEmpty, text: 'Be Responsible' },
    { to: '/bunker', icon: faBook, text: 'Bunker' },
    { to: '/sport', icon: faFutbolBall, text: 'Sport' },
    { to: '/animation', icon: faDice, text: 'Animation' },
    { to: '/urgence', icon: faTruckMedical, text: 'Urgence' },
    { to: '/contacts', icon: faCircleInfo, text: 'Contacts' },
];

function TabLinks({ to, icon, text, onClick }) {
    const location = useLocation().pathname; // Get the current location path

    // Check if the current location path matches the link path
    const regex = new RegExp(`^${to}($|/)`);
    const isActive = to ? regex.test(location) : false;

    return (
        <Link
            to={to}
            className={`tab-bar-item ${isActive ? 'active' : ''}`}
            onClick={onClick}
        >
            <FontAwesomeIcon icon={icon} size="lg" className="fa-fw" />
            <span>{text}</span>
        </Link>
    );
}

function TabBar() {
    const [isMoreVisible, setIsMoreVisible] = useState(false);

    const toggleMoreVisibility = () => {
        setIsMoreVisible(!isMoreVisible);
    };

    const handleLinksClick = () => {
        setTimeout(() => {
            setIsMoreVisible(false); // Close the more menu when a link is clicked
        }, 10);
    };

    return (
        <>
            <div id="tab-bar">
                <div>
                    {mainLinks.map((item, _) => (
                        <TabLinks
                            key={item.to}
                            to={item.to}
                            icon={item.icon}
                            text={item.text}
                            onClick={handleLinksClick}
                        />
                    ))}
                    <button onClick={toggleMoreVisibility}>
                        <FontAwesomeIcon
                            icon={faEllipsis}
                            size="xl"
                            className="fa-fw"
                        />
                        <span>Plus</span>
                    </button>
                </div>
            </div>

            <div
                id="container-tab-bar-more"
                className={isMoreVisible ? 'open' : 'closed'}
                onClick={handleLinksClick}
            >
                <div
                    id="tab-bar-more"
                    className={isMoreVisible ? 'open' : 'closed'}
                >
                    <p>Plus</p>
                    <div>
                        {extraLinks.map((item, _) => (
                            <TabLinks
                                key={item.to}
                                to={item.to}
                                icon={item.icon}
                                text={item.text}
                                onClick={handleLinksClick}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}

TabLinks.propTypes = {
    to: PropTypes.string,
    icon: PropTypes.object,
    text: PropTypes.string,
    onClick: PropTypes.func,
};

export default TabBar;
